import { render } from "./NestedInputs.vue?vue&type=template&id=24f47c32&scoped=true"
import script from "./NestedInputs.vue?vue&type=script&lang=js"
export * from "./NestedInputs.vue?vue&type=script&lang=js"

import "./NestedInputs.vue?vue&type=style&index=0&id=24f47c32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f47c32"]])

export default __exports__